function setCookie(name, value, hours) {
    const date = new Date();
    date.setTime(date.getTime() + hours * 60 * 60 * 1000); // Convertir horas a milisegundos
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${value}; ${expires}; path=/`;
}

function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (let cookie of cookies) {
        const [key, value] = cookie.split('=');
        if (key === name) {
            return value;
        }
    }
    return null; // No existe la cookie
}

function isCookieValid(name) {
    const cookieValue = getCookie(name);
    return cookieValue !== null; // Si es `null`, la cookie no existe
}

export {setCookie, getCookie, isCookieValid};